import {formatDate, formatTime} from '../helpers/helpers';
import {YANDEX_METRIKA_ID} from '../ids';
import {AnalyticsEventParams} from '../types/analytics';

export const emitYmEvent = (
  event: string,
  params: Partial<AnalyticsEventParams> = {},
) => {
  if (!window.ym) {
    return;
  }

  const currentDate = new Date();

  window.ym(YANDEX_METRIKA_ID, 'reachGoal', event, {
    product: 'UserProfile',
    event_timestamp: `${formatDate(currentDate)} ${formatTime(currentDate)}`,
    ...params,
  });
};
